export let ukList = [
    "United Kingdom",
    "Scotland",
    "England",
    "Northern Ireland",
    "Wales"
];

